// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 16px;
}

.full-width-field {
  grid-column: 1/-1;
}

@media (max-width: 600px) {
  .card-form-grid {
    grid-template-columns: 1fr;
  }
}
.global-card-info-cont {
  padding: 0 16px 16px 16px;
}

.global-card-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 8px;
  font-size: 10pt;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/companies/programs/programs-editor/reloadable-cards/reloadable-card-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE;IACE,0BAAA;EACF;AACF;AAEA;EACE,yBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,eAAA;AAAF","sourcesContent":[".card-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0 16px;\n}\n\n.full-width-field {\n  grid-column: 1 / -1;\n}\n\n@media (max-width: 600px) {\n  .card-form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.global-card-info-cont {\n  padding: 0 16px 16px 16px;\n}\n\n.global-card-info {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0 8px;\n  font-size: 10pt;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
